// Grows a textarea to fit its words, so a long one never scrolls inside itself (the editors' text boxes).
export const growToFit = (el) => { if (el) { el.style.height = "auto"; el.style.height = `${el.scrollHeight}px`; } };
